export type CommunitySectionConfig = {
  heading: string;
  paragraph1: string;
  paragraph2: string;
  ctaText: string;
  ctaHref: string;
  /** Full iframe `src` URL (e.g. YouTube embed). */
  videoEmbedSrc: string;
  /** Poster image shown before the user clicks play. */
  videoPosterSrc: string;
  sectionAriaLabel: string;
  videoIframeTitle: string;
};

const BASE_DEFAULT: CommunitySectionConfig = {
  heading: "Dank - №1 cannabis dispensary in Calgary community",
  paragraph1:
    "Dank Calgary dispensary store is your trusted source for a great selection of high-quality cannabis products. " +
    "More than a cannabis retail experience, Dank represents a lifestyle of excellence and quality. We are committed " +
    "to developing a true community spirit in Calgary so that those who are passionate about cannabis can come together.",
  paragraph2:
    "Our knowledgeable staff understands the current cannabis culture and can provide personalized recommendations " +
    "from our curated product selection. Calgary's recreational cannabis users can find popular strains and products " +
    "at amazing prices and exclusive perks for Dank Club members. Shop any of Dank's cannabis dispensaries in Calgary " +
    "for a comprehensive cannabis experience.",
  ctaText: "Read about us",
  ctaHref: "/about-us",
  videoEmbedSrc: "https://www.youtube.com/embed/YOUR_VIDEO_ID?rel=0&modestbranding=1&showinfo=0",
  videoPosterSrc: "/media/pages/home/cta/banner-shopping.webp",
  sectionAriaLabel: "Calgary Dispensary Community",
  videoIframeTitle: "Dank Cannabis dispensary - Calgary community video",
};

/** Slugs with tailored defaults; otherwise homepage defaults are used. */
export const COMMUNITY_SECTION_ALLOWED_SLUGS = ["homepage", "why-dank"] as const;

export function getDefaultCommunitySectionConfig(pageSlug: string): CommunitySectionConfig {
  if (pageSlug === "why-dank") {
    return {
      ...BASE_DEFAULT,
      heading: "Why Dank, Calgary’s community-first cannabis retailer",
      paragraph1:
        "From curated menus to budtenders who actually smoke what they sell, Dank is built for people who want more " +
        "than a transaction. We invest in education, honest recommendations, and a welcoming vibe whether you’re new " +
        "to cannabis or refining your favorites.",
      paragraph2:
        "Visit us in Calgary, order ahead for pickup where available, or explore delivery options in eligible zones. " +
        "However you shop, you get the same commitment to quality, compliance, and respect for the plant, and for you.",
      sectionAriaLabel: "Why Dank community",
      videoIframeTitle: "Dank Cannabis, community video",
    };
  }
  return { ...BASE_DEFAULT };
}
